import { createAction, props } from '@ngrx/store';
import { Question } from '../models/question.model';

export const setQuestion = createAction('[Question Component] SetQuestion', props<Question>());
